<hr>
<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="toolbar">
            <div class="row" style="margin-right: 0px; margin-left: 0px; text-align: right">
              <div class="col-md-12" style="text-align: right">
                <div style="margin-top: 5px !important; float: right">
                  <!-- <div class="" id="button-addon4" style="text-align: right">
                    <button class="btn btn-outline-secondary" style="margin-top: 0; height: 40px"
                      (click)="downloadAsPDF()" title="Salve em PDF">
                      <i class="bi bi-file-earmark-pdf"></i>
                    </button>

                  </div> -->
                </div>
              </div>
            </div>
          </div>

          <hr>
          <!-- <div class="col-md-4">
            <label for="">Data inicio:</label>
            <div class="form-group">
              <input type="date" [ngModel]="inicio | date:'yyyy-MM-dd'" (ngModelChange)="inicio = $event" name="dt"
                class="form-control form-control-rounded" #searchDate>
            </div>
            <label for="">Data fim:</label>
            <div class="form-group">
              <input type="date" [ngModel]="fim | date:'yyyy-MM-dd'" (ngModelChange)="fim = $event" name="dt"
                class="form-control form-control-rounded" #searchDate>
            </div>
            <button class="btn btn-outline-secondary" style="margin-top: 0; height: 40px" (click)="ativar()">
              <i class="bi bi-calendar-plus"></i>
            </button>
          </div> -->
          <div id="accordion">
            <div class="card">
              <div class="card-header" id="headingOne">
                <h5 class="mb-0">
                  <button class="btn btn-link text-decoration-none" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  <strong>Relatório de bens</strong> 
                  </button>
                </h5>
              </div>
          
              <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                <div class="card-body" *ngIf="!loading">
                    <div class="logo">
                      <span class="simple-text logo-mini">
                        <div class="logo-image-small">
                          <img src="./assets/img/eletronorte-logo.jpg" style="width: 100px" />
                        </div>
                      </span>
                      <span class="simple-text logo-normal text-center" style="padding-top: 5px; padding-bottom: 0px">
                        ELETRONORTE
                      </span>
                      <br>
                      <span class="simple-text text-center" data-color="white"
                        style="padding-top: 5px; padding-bottom: 0px; font-size: 10px">
                        EPatrimonio
                      </span>
                    </div>
                    <hr>
                    <div class="col-md-4"></div>
                    <div class="form-row">
                      <legend>Filtros:</legend>
                      <div class="col-md-6 mb-2">
                        <label for="matricula">Matricula</label> 
                        <ng-autocomplete 
                        id="matricula"
                        [data]="users"
                        [searchKeyword]="keywordMatricula"
                        (selected)='selectMat($event)'
                        [itemTemplate]="itemTemplateMatricula"
                        [notFoundTemplate]="notFoundTemplateMat">                                 
                      </ng-autocomplete>
                      
                      <ng-template #itemTemplateMatricula let-item>
                        <a [innerHTML]="item.nome"></a>
                      </ng-template>
                      
                      <ng-template #notFoundTemplateMat let-notFound>
                      <div [innerHTML]="notFound"></div>
                      </ng-template>
                      
                      </div>
                      <!-- <div class="col-md-2 d-inline p-4">
                        <button 
                        class="btn btn-outline-secondary mt-0" 
                        (click)="pesquisarMat()">
                          <i class="fa fa-search"></i>
                        </button>
                      </div> -->
                    </div>
                    <div class="form-row">
                      <div class="col-md-6 mb-2">
                        <label for="lotacao">Lotação</label> 
                        <ng-autocomplete 
                        id="lotacao"
                        [data]="lotacao"
                        [searchKeyword]="keywordLotacao"
                        (selected)='selectLot($event)'
                        [itemTemplate]="itemTemplateLotacao"
                        [notFoundTemplate]="notFoundTemplateLotacao">                                 
                      </ng-autocomplete>
                      
                      <ng-template #itemTemplateLotacao let-item>
                        <a [innerHTML]="item.dS_LOTACAO"></a>
                      </ng-template>
                      
                      <ng-template #notFoundTemplateLotacao let-notFound>
                      <div [innerHTML]="notFound"></div>
                      </ng-template>
                      </div>
                      <!-- <div class="col-md-2 d-inline p-4">
                        <button class="btn btn-outline-secondary mt-0" (click)="pesquisarLot()">
                          <i class="fa fa-search"></i>
                        </button>
                      </div> -->
                    </div>
                    <div class="form-row">
                      <div class="col-md-6 mb-2">
                          <label for="location">Unidade Operacional</label>
              
                          <ng-autocomplete 
                          id="location"
                          [data]="localizacao"
                          [searchKeyword]="keywordUnidade"
                          (selected)='selectEvent($event)'
                          [itemTemplate]="itemTemplateUnidade"
                          [notFoundTemplate]="notFoundTemplateUnidade"
                          >                                 
                        </ng-autocomplete>
                        
                        <ng-template #itemTemplateUnidade let-item>
                        <a [innerHTML]="item.dS_BPM_UNIDADE">
                        </a>
                        </ng-template>
                        
                        <ng-template #notFoundTemplateUnidade let-notFound>
                        <div [innerHTML]="notFound"></div>
                        </ng-template>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-md-6 mb-2">
                        <label for="sala">Sala</label>
                        <input type="text" id="sala" class="form-control txtformulario" [(ngModel)]="dS_BPM_SALA">
                      </div>
                    </div>
                    <button type="button" class="btn btn-outline-secondary text-center"
                    (click)="insertBens()">
                    <i class="bi bi-file-earmark-pdf"></i>  Gerar relatório de bens
                    </button>
                    <div class="row">
                      <div class="col-md-12 text-center" *ngIf="loading">
                        <img src="./assets/img/loading.png" class="loading" id="loadingImage" height="50" width="50" />
                      </div>
                    </div>
                  
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="headingTwo">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed text-decoration-none" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    <strong>Relatório de Movimentação</strong> 
                  </button>
                </h5>
              </div>
              <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                <div class="card-body" *ngIf="!loading">
                  <div class="form-row">
                    <div class="col-md-6 mb-2">
                      <label for="meuBem">Bens</label>
                      <input type="number" class="form-control txtformulario" id="meuBem" [(ngModel)]="nR_BPM_BEM_PATRIMONIAL"/>
                       <!-- <ng-autocomplete 
                        id="meuBem"
                        [data]="cadastro"
                        [searchKeyword]="keywordMeusBens"
                        (selected)='selectMeusBens($event)'
                        [itemTemplate]="itemTemplateMeusBens"
                        [notFoundTemplate]="notFoundTemplateMeusBens">                                 
                      </ng-autocomplete>
                      
                      <ng-template #itemTemplateMeusBens let-item>
                      <span [innerHTML]="item.dS_BPM_DESCRICAO_BEM">
                      </span>
                     
                      </ng-template>
                      
                      <ng-template #notFoundTemplateMeusBens let-notFound>
                      <div [innerHTML]="notFound"></div>
                      </ng-template>-->
                    </div>
                  </div>
                  <button type="button" class="btn btn-outline-secondary text-center"
                  (click)="insertMov()">
                  <i class="bi bi-file-earmark-pdf"></i>  Gerar relatório de Movimentação
                  </button>
                  <div class="row">
                    <div class="col-md-12 text-center" *ngIf="loading">
                      <img src="./assets/img/loading.png" class="loading" id="loadingImage" height="50" width="50" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="headingThree">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed text-decoration-none" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    <strong>Relatório de Inconsistência</strong>
                  </button>
                </h5>
              </div>
              <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                <div [formGroup]="form_incon" class="card-body" *ngIf="!loading">
                  <div class="form-row">
                    <div class="col-md-6 mb-2">
                      <label for="mat_gestor">Matricula Gestor</label>
                              <ng-autocomplete 
                              id="mat_gestor"
                              [data]="dataGestor"
                              [searchKeyword]="keywordMatGestor"
                              (selected)='selectMatGestor($event)'
                              [itemTemplate]="itemTemplateMatGestor"
                              [notFoundTemplate]="notFoundTemplateMatGestor">                                 
                            </ng-autocomplete>
                            
                            <ng-template #itemTemplateMatGestor let-item>
                              <a [innerHTML]="item.nome"></a>
                            </ng-template>
                            
                            <ng-template #notFoundTemplateMatGestor let-notFound>
                            <div [innerHTML]="notFound"></div>
                            </ng-template>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col-md-6 mb-2">
                      <label for="mat_gestor">Matricula do Usuário</label>
                          
                              <ng-autocomplete 
                              id="mat_user"
                              [data]="users"
                              [searchKeyword]="keywordMatUser"
                              (selected)='selectMatUser($event)'
                              [itemTemplate]="itemTemplateMatUser"
                              [notFoundTemplate]="notFoundTemplateMatUser">                                 
                            </ng-autocomplete>
                            
                            <ng-template #itemTemplateMatUser let-item>
                              <a [innerHTML]="item.nome"></a>
                            </ng-template>
                            
                            <ng-template #notFoundTemplateMatUser let-notFound>
                            <div [innerHTML]="notFound"></div>
                            </ng-template>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col-md-6 mb-2">
                      <label for="location">Unidade Operacional</label>
                          
                      <ng-autocomplete 
                      id="location"
                      [data]="localizacao_incon"
                      [searchKeyword]="keywordUnidadeIncon"
                      (selected)='selectUnidade($event)'
                      [itemTemplate]="itemTemplateInconUnidade"
                      [notFoundTemplate]="notFoundTemplateInconUnidade"
                      >                                 
                    </ng-autocomplete>
                    
                    <ng-template #itemTemplateInconUnidade let-item>
                    <a [innerHTML]="item.dS_BPM_UNIDADE">
                    </a>
                    </ng-template>
                    
                    <ng-template #notFoundTemplateInconUnidade let-notFound>
                    <div [innerHTML]="notFound"></div>
                    </ng-template>
                  
              
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col-md-6 mb-2">
                      <label for="status">Situação</label>
                      <select multiple class="form-control" id="status" formControlName="status">
                      <option value="0" selected>Sem filtro</option>
                      <option value="1">Com Inconsistencia ativa</option>
                      <option value="2">Com Inconsistencia que foram resolvidas</option>
                      
                     </select>
                    </div>
                  </div>
                  <button type="button" class="btn btn-outline-secondary text-center"
                  (click)="insertIncon()">
                  <i class="bi bi-file-earmark-pdf"></i>  Gerar relatório de Inconsistencia
                  </button>
                  <div class="row">
                    <div class="col-md-12 text-center" *ngIf="loading">
                      <img src="./assets/img/loading.png" class="loading" id="loadingImage" height="50" width="50" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="table-responsive table-hover" style="overflow-y: hidden; overflow-x: auto">
            <div class="logo">
              <span class="simple-text logo-mini">
                <div class="logo-image-small">
                  <img src="./assets/img/eletronorte-logo.jpg" style="width: 100px" />
                </div>
              </span>
              <span class="simple-text logo-normal text-center" style="padding-top: 5px; padding-bottom: 0px">
                ELETRONORTE
              </span>
              <br>
              <span class="simple-text text-center" data-color="white"
                style="padding-top: 5px; padding-bottom: 0px; font-size: 10px">
                EPatrimonio
              </span>
            </div>
            <hr>
            <div class="col-md-4"></div>
            <table id="pdfTable" class="table table-hover" *ngIf="!loading">
              <thead>
                <tr>
                  <th scope="col">Matricula</th>
                  <th scope="col">Nome do Responsavel</th>
                  <th scope="col">Descrição</th>
                  <th scope="col">Cod.</th>
                  <th scope="col">Sala</th>
                  <th scope="col">Lotação</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let bens of relatorioBens">
                  <td class="text-truncate">{{bens.cD_CDU_MATRICULA_USUARIO_CAUTELA}}</td>
                  <td class="text-truncate">{{bens.dS_NOME}}</td>
                  <td class="text-truncate">{{bens.dS_BPM_DESCRICAO_BEM}}</td>
                  <td class="text-truncate">{{bens.nR_BPM_BEM_PATRIMONIAL}}</td>
                  <td class="text-truncate">{{bens.dS_BPM_SALA}}</td>
                  <td class="text-truncate">{{bens.dS_LOTACAO}}</td>
                </tr>
              </tbody>
            </table>
            <div class="row">
              <div class="col-md-12 text-center" *ngIf="loading">
                <img src="./assets/img/loading.png" class="loading" id="loadingImage" height="50" width="50" />
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>



</div>